import styled from 'styled-components';
import { Typography } from '../../../../ui/Typography';

export const PhoneFieldHint = styled(Typography)`
  display: block;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 10px;
`;

export const Disclaimer = styled.div`
  background-color: #fff9e8;
  padding: 16px 20px;
  border-radius: 14px;
  margin-top: 10px;
`;
